// extracted by mini-css-extract-plugin
export default {"btop":"_258b793141 ace9c953c6 a5e8c3f510","icon":"_7217aba30e ed1910560c","btoppink":"_53aae53b0a _8d04c3d409"};